import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge/es5'; // 使用es5版本，兼容低版本浏览器

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
